<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                title="TDS VDS List"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                    <div class="d-flex align-items-center justify-content-between filter-label">
                        <label for="colFormLabel" class="col-form-label">Party: </label>
                        <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>

                    <AsyncSelect
                        placeholder="Select Party"
                        v-model="singleContact"
                        :api-service="fetchContactProfiles"
                        :format-label="formatPatientLabel"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                    <label for="colFormLabel" class="col-form-label">Accounting Head</label>
                    <v-select
                        v-model="params.account_head_id"
                        :options="accountHeads"
                        label="name"
                        :reduce="(item) => item.id"
                        placeholder="Select head"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                    <label for="colFormLabel" class="col-form-label">VDS Section Head</label>
                    <v-select
                        v-model="params.vds_rate_id"
                        placeholder="Select VDS Section Head"
                        :options="vdsRateList"
                        :reduce="item => item.id"
                        label="name"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                    <label for="colFormLabel" class="col-form-label">TDS Section Head</label>
                    <v-select
                        v-model="params.tds_rate_id"
                        placeholder="Select TDS Section Head"
                        :options="tdsRateList"
                        :reduce="item => item.id"
                        label="name"
                    />
                </div>
            </DateQuerySetter>
        </div>

        <div class="d-flex justify-content-end px-2 mb-2 gap-1">
            <div v-if="showPrint">
                <div class="challan-inline-spacing">
                    <div class="form-check form-check-inline mt-0">
                        <input
                            v-model="sectionType"
                            class="form-check-input"
                            type="radio" name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="tds"
                        />
                        <label class="form-check-label" for="inlineRadio1">TDS</label>
                    </div>

                    <div class="form-check form-check-inline mt-0">
                        <input v-model="sectionType"
                            class="form-check-input"
                            type="radio" name="inlineRadioOptions"
                            id="inlineRadio2"
                            value="vds"
                        />
                        <label class="form-check-label" for="inlineRadio2">VDS</label>
                    </div>
                </div>
            </div>
            <button v-if="showPrint" @click="goToPrint" class="btn btn-primary btn-block waves-effect waves-float waves-light print-btn">
                Print
            </button>
            <button @click="exportTable" class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect">
                Export
            </button>
        </div>

        <div class="px-2 mt-1">
            <ul class="nav nav-tabs custom-nav-tab">
                <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :class="['nav-link', { active: activeTab.id == tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                        {{ tab.title }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
            <TdsVdsListTable
                :tableItems="tableItems"
            />
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            :isFilterable="true"
            :companyRoles="companyRoles"
        />
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import TdsVdsListTable from '@/components/molecule/company/compliance/tds-vds-register/TdsVdsListTable.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleCompliance from '@/services/modules/compliance/compliance';
import handleReport from "@/services/modules/accountingReport";
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleRole from "@/services/modules/role";
import handleContact from "@/services/modules/contact";
import handleTdsVds from '@/services/modules/procurement/tdsVds'
import handleCompany from "@/services/modules/company";
import pdfPrinter from '@/services/utils/pdf/tdsVds/tdsVdsClientWise';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const loading = ref(false)
const accountHeads = ref([]);
const companyRoles = ref([]);
const tableItems = ref([]);
const params = ref({
    offset: 10,
    tds_rate_id: null,
    vds_rate_id: null,
    account_head_id: null
});
const tdsRateList = ref([]);
const vdsRateList = ref([]);
const singleContact = ref(null);
const companyInfo = ref(null);
const sectionType = ref('tds');

const token = computed(() => localStorage.getItem('token'));

const tabs = [
    { id: 'paid', title: 'Paid Transaction' },
    { id: 'due', title: 'Due Transaction' },
    { id: 'challan', title: 'A Challan' },
    { id: 'no_tds_vds', title: 'NO TDS VDS' }
];
const activeTab = ref(tabs.find(tab => tab.id === route.query.tab) || tabs[0]);
const showPrint = computed(() => activeTab.value.id === 'paid' || activeTab.value.id === 'due' || activeTab.value.id === 'challan');

const {
    fetchTdsVdsRegisterByBill
} = handleCompliance();
const { fetchAccountHeads } = handleReport();
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchTdsRateList, fetchVdsRateList } = handleTdsVds();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF, formatTdsVdsPrintValue } = pdfPrinter();

const setActiveTab = async (tab) => {
    activeTab.value = tab;
    let routeQuery = Object.assign({}, route.query);
    delete routeQuery.page;
    await router.replace({
        query: {
            ...routeQuery,
            tab: tab.id
        }
    });
    getList();
}

const goToPrint = async () => {
    const payload = getPrintPayload();
    loading.value = true;
    let query = getQuery();
    query += '&is_all=1';
    const res = await fetchTdsVdsRegisterByBill(query);
    loading.value = false;
    if (!res.status) {
        showError(res.message);
        return;
    }
    const rows = res.data.map(item => ({ ...item, client_name: item.party_name }));
    const amountKey = sectionType.value === 'tds' ? 'tds_amount' : 'vds_amount';
    const formattedData = formatTdsVdsPrintValue(rows, amountKey);
    exportToPDF(companyInfo.value, formattedData, payload);
}

const exportTable = () => {
    let query = getQuery();
    query += '&is_export=1';
    query += '&_token=' + token.value;
    const url = `${process.env.VUE_APP_BASE_URL}/export/compliance/tds-vds-list${query}`;
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.click();
}

const resolveName = (list, id) => {
    if (!id) return '';
    const match = list.find(item => item.id === id);
    return match ? match.name : '';
}

const getPrintPayload = () => {
    return {
        start_date: route.query.start,
        end_date: route.query.end,
        party: singleContact.value ? singleContact.value.name : '',
        account_head_name: resolveName(accountHeads.value, params.value.account_head_id),
        vds_section: resolveName(vdsRateList.value, params.value.vds_rate_id),
        tds_section: resolveName(tdsRateList.value, params.value.tds_rate_id),
        payment_status: activeTab.value.title,
        section_type: sectionType.value.toUpperCase()
    };
}

const onClickToGo = () => {
    getList();
}

const onSearchContact = (contact) => {
    singleContact.value = contact;
}

const onOpenContactSearchModal = () => {
    store.state.isModalOpenThree = true;
}

const setPagination = (data) => {
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page
    });
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    getList();
}

const getAccountHeads = async () => {
    const res = await fetchAccountHeads(route.params.companyId);
    if (res.status) {
        accountHeads.value = res.data;
    }
}

const getCompanyRoles = async () => {
    const res = await fetchCompanyDefaultRoles(`?company_id=${route.params.companyId}`);
    if (res.status) {
        companyRoles.value = res.data;
    }
}

const getTdsRates = async () => {
    let query = getQuery();
    query += '&with_code=1';
    const res = await fetchTdsRateList(query);
    if (res.status) {
        tdsRateList.value = res.data;
    }
}

const getVdsRates = async () => {
    let query = getQuery();
    query += '&with_code=1';
    const res = await fetchVdsRateList(query);
    if (res.status) {
        vdsRateList.value = res.data;
    }
}

const getCompany = async () => {
    const res = await fetchCompanyInfo(route.params.companyId);
    if (res.status) {
        companyInfo.value = res.data;
    }
}

const getList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = [];
    const res = await fetchTdsVdsRegisterByBill(query);
    if (!res.status) {
        store.commit("resetPagination")
        loading.value = false
        return
    }
    tableItems.value = res.data.data;
    setPagination(res.data)
    loading.value = false
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (singleContact.value) query += '&contact_profile_id=' + singleContact.value.id;
    if (params.value.account_head_id) query += '&account_head_id=' + params.value.account_head_id;
    if (params.value.tds_rate_id) query += '&tds_rate_id=' + params.value.tds_rate_id;
    if (params.value.vds_rate_id) query += '&vds_rate_id=' + params.value.vds_rate_id;
    if (activeTab.value.id === 'no_tds_vds') query += '&no_tds_vds=1';
    if (activeTab.value.id === 'challan') query += '&challan=1';
    if (activeTab.value.id === 'paid' || activeTab.value.id === 'due') query += '&payment_status=' + activeTab.value.id;
    query += '&offset=' + params.value.offset;
    return query;
}

onMounted(() => {
    Promise.all([
        getAccountHeads(),
        getCompanyRoles(),
        getTdsRates(),
        getVdsRates(),
        getCompany()
    ])
})
</script>

<style>
.tds-vds-query-setter .action-btn-setter {
    margin-bottom: 1.5% !important;
}
.challan-inline-spacing {
    margin-top: 6px !important;
}
</style>
